import {LogLevel} from '../../log-level';
import {LoggerAppenderConfig} from '../logger-appender-config';

/**
 * XHR appender config
 */
export class XhrAppenderConfig extends LoggerAppenderConfig {
  enabled = false;

  /**
   * Path of API that will handle the logs
   * @type {string}
   */
  path: string = '/logs';

  /**
   * API HTTP Method
   * @type {string}
   */
  method: 'GET' | 'POST' | 'PUT' = 'POST';

  /**
   * Headers
   */
  headers: {
    [headerName: string]: string;
  } = {};

  /**
   * How many times to try to resend logs to the server. If this value is exceeded, attempts to send to the server will
   * be stopped until the browser is restarted.
   */
  attempts: number = 3;

  /**
   * Timeout between attempts to send logs to the server.
   */
  attemptTimeout: number = 10000;

  /**
   * Minimum level of message that will trigger sending logs to server; Critical by default
   */
  triggerLevel: LogLevel = LogLevel.Critical;

  /**
   * Number of chunks to store in sending queue
   * @type {number}
   */
  size: number = 5;

  /**
   * Key for localStorage to store sending queue
   * @type {string}
   */
  localStorageKey: string = 'hoteza.logger.xhrQueue';
}
